import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import {successEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {CSSTransition} from 'react-transition-group';
import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const DebtPaymentContactUsSuccess = (props) => {
  const [mount, setMount] = useState(false);

  useEffect(() => {
    if (props.currentStep === successEnum.CONTACTUS) {
      setMount(true);
      if (props.isPrivate) {
        gaEvent(
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUSSUCCESS.category,
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUSSUCCESS.eventType,
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUSSUCCESS.eventParams,
        );
      } else {
        gaEvent(
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUSSUCCESS.category,
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUSSUCCESS.eventType,
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUSSUCCESS.eventParams,
        );
      }
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  let mainImg = require('../images/icons-ok-done.svg');

  return (
    <CSSTransition key={7} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='קיבלנו את הפנייה!' classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='נחזור אליכם תוך יום עסקים אחד' />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit isBusiness={!props.isPrivate} formid='' text='נהיה בקשר' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default DebtPaymentContactUsSuccess;
